module.exports = {
   name: 'limit',
   gen_template: `
      {
         "coa": "ASSET",
         "code": "{{random.alphaNumeric}}{{random.number}}{{random.alphaNumeric}}{{random.number}}", 
         "name": "{{lorem.word}}"
      }
   `,
   wizard: {
      actionBtn: 'Save',
      action: 'limit_config',
      pages: [
         {
            title: 'Currency limit',
            subtitle: 'Configure new limit',
            forms: [
               {
                  type: 'text', form_type: 'text', label: 'Code', model: 'code',
                  validation: 'required|min:1|max:50', class: 'col-12 col-md-6'
               },
               {
                  type: 'text', form_type: 'text', label: 'Name', model: 'name',
                  validation: 'required|min:3|max:150', class: 'col-12 col-md-6'
               },
               {
                  type: 'text', form_type: 'text', label: 'Min Account Balance', model: 'min_bal',
                  validation: 'required|min:1|max:9|numeric', class: 'col-12 col-md-6'
               },
               {
                  type: 'text', form_type: 'text', label: 'Max Account Balance', model: 'max_bal',
                  validation: 'required|min:1|max:9|numeric', class: 'col-12 col-md-6'
               },
               {
                  type: 'textarea', form_type: 'text', label: 'Description', model: 'description',
                  validation: 'required|min:10|max:500', class: 'col-12'
               },
            ],
         }
      ]
   },
   table: {
      title: 'GL Configs',
      subtitle: 'A list of configured general ledgers',
      table_fields: [
         { name: 'Code', align: 'l' },
         { name: 'Name', align: 'l' },
         { name: 'Min Account Balance', align: 'l' },
         { name: 'Max Account Balance', align: 'l' },
         { name: 'actions', align: 'c' }
      ],
      searchFields: ["code", "name", "min_account_bal", "max_account_bal"],
      rowData: [
         { type: 'text', field: 'code', class: 'left bolder small' },
         { type: 'text', field: 'name', class: 'left bolder' },
         { type: 'text', field: 'min_account_bal', class: 'left bolder' },
         { type: 'text', field: 'max_account_bal', class: 'left bolder' },
         {
            type: 'action', field: 'name', class: 'center', icon: '', actions: [
               // {type: 'title', title: 'Actions'},
               {
                  type: 'menu', title: 'Edit', event: 'client:edit', icon: 'ico-right', params: [
                     { key: 'client', field: '*' }
                  ]
               },
               {
                  type: 'menu', title: 'View', event: 'client:view', icon: 'ico-reply', params: [
                     { key: 'email', field: 'email' },
                     { key: 'name', field: 'name' }
                  ]
               },
               // {type: 'divider'},
               {
                  type: 'menu', title: 'Delete', event: 'client:delete', icon: 'ico-mail-a', params: [
                     { key: 'email', field: 'email' }
                  ]
               },
            ]
         },
      ]
   },
}